import React, { lazy } from 'react';

// const EInvoiceMSIC = lazy(() =>
//   import(
//     'containers/SystemAdminModule/EInvoiceModule/EinvoiceMSIC'
//   ).then(module => ({
//     default: module.EInvoiceMISC,
//   })),
// );

const EInvoiceClassification = lazy(() =>
  import(
    'containers/SystemAdminModule/EInvoiceModule/EinvoiceClassification'
  ).then(module => ({
    default: module.EInvoiceClassification,
  })),
);

const einvoiceRoutes = [
  // {
  //   props: { exact: true, path: '/common-settings/kbli-setup' },
  //   component: <EInvoiceMSIC />,
  // },
  {
    props: { exact: true, path: '/common-settings/classification' },
    component: <EInvoiceClassification />,
  },
];

export default einvoiceRoutes;
